import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SkeletonBody from '@afosto/components-react/SkeletonBody';
import { allocation as allocationApi } from '@afosto/wms/api/Allocation';
import { locations as locationsApi } from '@afosto/wms/api/Locations';

const ClaimLocationFormatter = ({ claimId }) => {
  const [location, setLocation] = useState(null);
  const [isLoadingLocation, setIsLoadingLocation] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const fetchClaimLocation = async () => {
      try {
        setIsLoadingLocation(true);

        const response = await allocationApi.getClaim(claimId);
        const { data } = response;

        if (data?.location_id) {
          const locationResponse = await locationsApi.getLocation(data.location_id);
          const { data: locationData = null } = locationResponse;

          if (isMounted) {
            setLocation(locationData);
          }
        } else if (isMounted) {
          setLocation(null);
        }
      } catch (err) {
        if (isMounted) {
          setLocation(null);
        }
      } finally {
        if (isMounted) {
          setIsLoadingLocation(false);
        }
      }
    };

    if (claimId) {
      fetchClaimLocation();
    }

    return () => {
      isMounted = false;
    };
  }, [claimId]);

  if (isLoadingLocation) {
    return <SkeletonBody lines={1} />;
  }

  return location?.name ?? '-';
};

ClaimLocationFormatter.propTypes = {
  claimId: PropTypes.string,
};

ClaimLocationFormatter.defaultProps = {
  claimId: undefined,
};

export default ClaimLocationFormatter;
